import debounce from 'lodash/debounce';
import presetVariable from './presetVariable';
import css from './index.module.scss';
import { loadScript } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';

interface props {
    children: JSX.Element;
    scriptUrl?: string;
    success_message?: string;
    error_message?: string;
    successCallback?: () => void;
    errorCallback?: () => void;
    placeholder?: string;
}

const Mailchimp = ({
    children,
    success_message,
    error_message,
    scriptUrl = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js',
    successCallback,
    errorCallback,
}: props) => {
    const { useEffect, useLang, useRouter, isMobile } = useGlobal();
    const router = useRouter();
    const { t } = useLang('shared');
    const { locale } = useRouter();

    const sleep = (time = 0) => {
        return new Promise((resolve) => {
            setTimeout(resolve, time);
        });
    };

    const validateMessages: any = {
        // 字段名： 错误消息
        EMAIL: t('common.email_validation_error'),
        COUNTRY: null,
    };

    useEffect(() => {
        let otherErrObserver: any = null;
        let successObserver: any = null;

        // prevent reload again
        if (router.isReady) {
            loadScript(scriptUrl).then(() => {
                const win = window as any;
                const $ = win.jQuery;
                presetVariable();

                // 原插件是基于jquery写的业务，为了适配本补充一些jquery代码来适配功能页面业务，
                const submit_btn = $('#mc-embedded-subscribe');
                const input = $('#mce-EMAIL');
                const config = { childList: true, subtree: true };

                // 原插件采用失焦校验，此处更改为提交校验
                submit_btn.on('click', async function () {
                    await sleep(10);
                    const group_list = $('.mc-field-group');
                    let is_has_error_filed = false;
                    group_list.each(function (_i: number, domEle: any) {
                        const mce_inline_error = $(domEle).find('div.mce_inline_error');
                        const custom_error_msg = $(domEle).find('div.custom_error_msg');
                        const filedName = $(domEle).data('name');
                        if (!mce_inline_error.length) {
                            custom_error_msg.hide();
                            return;
                        }

                        const isShowError = mce_inline_error[0]?.style?.display !== 'none';

                        if (!isShowError) {
                            custom_error_msg.hide();
                            return;
                        }

                        is_has_error_filed = isShowError;
                        const rawMsg = mce_inline_error.text();
                        const customMsg = validateMessages[filedName];

                        custom_error_msg.text(customMsg || rawMsg);
                        custom_error_msg.show();
                    });
                    is_has_error_filed && errorCallback && errorCallback();
                });

                const otherErrorCallback = function (mutationsList: any) {
                    const mutation = mutationsList.filter((item: any) => item.type === 'childList');

                    if (mutation.length > 0) {
                        $('.custom_error_msg').text('').hide();
                        // const text = $('#mce-error-response').text()
                        $('#custom-responses-msg').text(error_message || t('common.email_unknown_error'));
                        $('#custom-responses-msg').removeClass('success').addClass('error');
                        $('#custom-responses-msg.error').show().delay(5000).fadeOut();
                        errorCallback && errorCallback();
                    }
                };

                const successObCallback = function (mutationsList: any) {
                    const mutation = mutationsList.filter((item: any) => item.type === 'childList');

                    if (mutation.length > 0) {
                        $('.custom_error_msg').text('').hide();
                        $('#custom-responses-msg').text(success_message || t('common.email_validation_success'));
                        $('#custom-responses-msg').removeClass('error').addClass('success');
                        if (['kr', 'jp'].includes(locale) && isMobile) {
                            $('.mc-field-group').css('margin-bottom', '0.4rem');
                            setTimeout(() => {
                                $('.mc-field-group').css('margin-bottom', '0.25rem');
                            }, 5100);
                        }
                        $('#custom-responses-msg.success').show().delay(5000).fadeOut();
                        successCallback && successCallback();
                    }
                };
                otherErrObserver = new MutationObserver(otherErrorCallback);
                successObserver = new MutationObserver(successObCallback);

                if (document.querySelector('#mce-error-response')) {
                    otherErrObserver.observe($('#mce-error-response')[0], config);
                }
                if (document.querySelector('#mce-success-response')) {
                    successObserver.observe($('#mce-success-response')[0], config);
                }

                input.on(
                    'input',
                    debounce(() => {
                        if (!input.val()) {
                            const curr_filed_msg = input.siblings('.custom_error_msg');
                            curr_filed_msg.hide();
                            $('#custom-responses-msg').hide();
                        }
                    }, 200),
                );
            });
        }
        return () => {
            otherErrObserver?.disconnect();
            successObserver?.disconnect();
        };
    }, []);

    return <div className={css.mailchimp}>{children}</div>;
};

export default Mailchimp;
